<template>
  <figure class="dow-agg">
    <ul>
      <li v-for="a in agg" :key="a.key">
        <h4 class="subtitle">{{ dayOfWeek(a.key) }}</h4>
        <p class="content">{{ a.count.toLocaleString() }}</p>
      </li>
    </ul>
  </figure>
</template>

<script>
const DaysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default {
  props: {
    agg: Array
  },
  methods: {
    dayOfWeek(i) {
      i = typeof i === "string" ? parseInt(i, 10) : i;
      return DaysOfWeek[i] || i;
    },
  }
}
</script>

<style lang="scss" scoped>
.dow-agg {
  ul {
    display: flex;
    justify-content: center;
    li {
      flex-grow: 0;
      margin: 0 20px;
      text-align: center;
      border: 1px solid #e5e5e5;
      border-radius: 14px;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.02);
      .subtitle {
        font-weight: bolder;
        background-color: rgb(202, 0, 27);
        color: #fff;
        padding: 5px 15px;
        margin-bottom: 0;
      }
      .content {
        padding: 0;
        margin: 10px 20px;
      }
    }
  }
}
</style>